import { __extends } from "tslib";
import { BitmapFilter } from './BitmapFilter';
import { assert, release, NumberUtilities } from '@awayfl/swf-loader';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: GlowFilter
var GlowFilter = /** @class */ (function (_super) {
    __extends(GlowFilter, _super);
    function GlowFilter(color, alpha, blurX, blurY, strength, quality, inner, knockout) {
        if (color === void 0) { color = 16711680; }
        if (alpha === void 0) { alpha = 1; }
        if (blurX === void 0) { blurX = 6; }
        if (blurY === void 0) { blurY = 6; }
        if (strength === void 0) { strength = 2; }
        if (quality === void 0) { quality = 1; }
        if (inner === void 0) { inner = false; }
        if (knockout === void 0) { knockout = false; }
        var _this = _super.call(this) || this;
        _this.filterName = 'glow';
        _this.color = color;
        _this.alpha = alpha;
        _this.blurX = blurX;
        _this.blurY = blurY;
        _this.strength = strength;
        _this.quality = quality;
        _this.inner = inner;
        _this.knockout = knockout;
        return _this;
    }
    GlowFilter.FromUntyped = function (obj, sec) {
        // obj.colors is an array of RGBA colors.
        // Here it contains exactly one color object, which maps to color and alpha.
        release || assert(obj.colors && obj.colors.length === 1, 'colors must be Array of length 1');
        var color = obj.colors[0] >>> 8;
        var alpha = (obj.colors[0] & 0xff) / 0xff;
        return new sec.flash.filters.GlowFilter(color, alpha, obj.blurX, obj.blurY, obj.strength, obj.quality, obj.inner, obj.knockout);
    };
    Object.defineProperty(GlowFilter.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value /*uint*/) {
            this._color = (value >>> 0) & 0xffffff;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlowFilter.prototype, "alpha", {
        get: function () {
            return this._alpha;
        },
        set: function (value) {
            this._alpha = NumberUtilities.clamp(+value, 0, 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlowFilter.prototype, "blurX", {
        get: function () {
            return this._blurX;
        },
        set: function (value) {
            this._blurX = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlowFilter.prototype, "blurY", {
        get: function () {
            return this._blurY;
        },
        set: function (value) {
            this._blurY = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlowFilter.prototype, "inner", {
        get: function () {
            return this._inner;
        },
        set: function (value) {
            this._inner = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlowFilter.prototype, "knockout", {
        get: function () {
            return this._knockout;
        },
        set: function (value) {
            this._knockout = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlowFilter.prototype, "quality", {
        get: function () {
            return this._quality;
        },
        set: function (value /*int*/) {
            this._quality = NumberUtilities.clamp(value | 0, 0, 15);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlowFilter.prototype, "strength", {
        get: function () {
            return this._strength;
        },
        set: function (value) {
            this._strength = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    GlowFilter.prototype.toAwayObject = function () {
        return this;
    };
    GlowFilter.prototype.clone = function () {
        return new this.sec.flash.filters.GlowFilter(this._color, this._alpha, this._blurX, this._blurY, this._strength, this._quality, this._inner, this._knockout);
    };
    // Called whenever the class is initialized.
    GlowFilter.classInitializer = null;
    // List of static symbols to link.
    GlowFilter.classSymbols = null; // [];
    // List of instance symbols to link.
    GlowFilter.instanceSymbols = null;
    return GlowFilter;
}(BitmapFilter));
export { GlowFilter };
